import { RouterProvider } from "react-router-dom";
import router from "./router";
import rybbit from "@rybbit/js";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    rybbit.init({
      analyticsHost: "https://tracking.criss.com.cn/api",
      siteId: "2",
    });
  }, []);
  return <RouterProvider router={router} />;
}

export default App;
